/*移动端检测*/
// https://h5.youshr.com/index
// (()=>{
//   const is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
//   if (!is_mobi) {
//     window.location.href = "https://www.youshr.com/";
//   }
// })()

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/style/minireset.css'
import './assets/style/base.less'
import Vue from 'vue'
import App from './App'
import router from './router'
import util from './util';
import './assets/js/global';
import 'swiper/dist/css/swiper.css'
import 'vant/lib/index.css';
// import updateUpdate from './utils/wxConfig'
// updateUpdate();
// MintUI
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
Vue.use(Mint);
Vue.use(util);
// vant UI 框架配置
import './utils/vantConfig'
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js